var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBriefing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1646_15664)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.6,
    fill: "#6224C6",
    stroke: "#F6F0FF",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.86364 4H7.02273C6.45789 4 6 4.43972 6 4.98214V14.0179C6 14.5603 6.45789 15 7.02273 15H13.9773C14.5421 15 15 14.5603 15 14.0179V9.89286C15 8.80801 14.0842 7.92857 12.9545 7.92857H11.9318C11.367 7.92857 10.9091 7.48885 10.9091 6.94643V5.96429C10.9091 4.87944 9.99331 4 8.86364 4ZM12.4693 9.72834C12.6006 9.55179 12.558 9.30643 12.3741 9.18032C12.1903 9.05421 11.9348 9.0951 11.8035 9.27166L10.0387 11.6443L9.15291 10.7936C8.99315 10.6402 8.73413 10.6402 8.57437 10.7936C8.41461 10.9471 8.41461 11.1958 8.57437 11.3492L9.80164 12.5278C9.88667 12.6094 10.0048 12.651 10.1247 12.6415C10.2445 12.632 10.3539 12.5723 10.4238 12.4783L12.4693 9.72834Z",
    fill: "#F6F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0297 4.16547C11.4643 4.64768 11.7273 5.2765 11.7273 5.96429V6.94643C11.7273 7.05491 11.8189 7.14286 11.9318 7.14286H12.9545C13.6708 7.14286 14.3256 7.39535 14.8277 7.81271C14.3434 6.03232 12.8837 4.63055 11.0297 4.16547Z",
    fill: "#F6F0FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1646_15664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefing);
export default __webpack_public_path__ + "static/media/briefing.3f9b3c253e2b92f8f906a4d50d989c95.svg";
export { ForwardRef as ReactComponent };